{{ value | currencyFormat: currencyCode:display:position:format }}
